import axios from "axios";
import { baseUrl } from "./baseUrl";

export const fetchCreditPaymentBlockStatus = async (customerId) => {
  if (!customerId) {
    return null;
  }

  const response = await axios.get(
    `${baseUrl}/shops/${customerId}/credit-order-block`
  );

  return response?.data?.data || null;
};

export const buildCreditBlockInitialMessage = (count) =>
  `مشتری ${count} فاکتور پرداخت اعتباری باز دارد و امکان ثبت سفارش جدید میسر نمی‌باشد. آیا مایل به پرداخت هستید؟`;

export const buildCreditBlockFollowUpMessage = () =>
  "آیا مایل به پرداخت فاکتورهای پرداخت اعتباری دیگر هستید؟";

export const applyCreditBlockFromStatus = (status, customerId) => {
  if (!status?.blocked) {
    return null;
  }

  if (status.block_type === "credit_expired") {
    return {
      type: "expired",
      customerId,
      message: status.message || "اعتبار مشتری به پایان رسیده و امکان ثبت سفارش جدید وجود ندارد.",
      orders: status.orders || [],
      count: status.count || (status.orders?.length ?? 0),
    };
  }

  if (status.orders?.length) {
    return {
      type: "payment",
      customerId,
      orders: status.orders,
      count: status.count || status.orders.length,
    };
  }

  return null;
};

export const navigateToCreditPayment = (navigate, orderId, customerId, returnTo = "/") => {
  navigate(`/panel/payment/${orderId}`, {
    state: {
      creditBlockReturnTo: returnTo,
      creditBlockCustomerId: customerId,
    },
  });
};

export const extractCreditBlockFromError = (error) => {
  const payload = error?.response?.data;
  if (!payload?.data) {
    return null;
  }

  if (payload.code === "425" || payload.data.block_type === "credit_expired") {
    return {
      type: "expired",
      message:
        payload.message ||
        payload.data.message ||
        "اعتبار مشتری به پایان رسیده و امکان ثبت سفارش جدید وجود ندارد.",
      orders: payload.data.orders || [],
      count: payload.data.count || (payload.data.orders?.length ?? 0),
    };
  }

  if (payload.code === "424" && payload.data.orders?.length) {
    return {
      type: "payment",
      orders: payload.data.orders,
      count: payload.data.count,
    };
  }

  return null;
};
